import { TFunction } from 'i18next'
import { SurveyType } from '@/features/forms-and-surveys/types'

// This function will be used to get translated survey type labels
export function getTranslatedSurveyTypeLabel(
  t: TFunction,
  type: SurveyType | string
) {
  switch (type) {
    case 'OpenFeedback':
      return t('surveys.surveyTypeOpenFeedback')
    case 'CustomerSatisfactionScore':
      return t('surveys.surveyTypeCustomerSatisfaction')
    case 'NetPromoterScore':
      return t('surveys.surveyTypeNetPromoterScore')
    case 'CustomerEffortScore':
      return t('surveys.surveyTypeCustomerEffortScore')
    case 'ProductMarketFit':
      return t('surveys.surveyTypeProductMarketFit')
    case 'Onboarding':
      return t('surveys.surveyTypeOnboarding')
    case 'UserInterview':
      return t('surveys.surveyTypeUserInterview')
    default:
      return type
  }
}

export const getSurveyTypeColor = (type: SurveyType | string) => {
  switch (type) {
    case 'OpenFeedback':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300'
    case 'CustomerSatisfactionScore':
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
    case 'NetPromoterScore':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300'
    case 'CustomerEffortScore':
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300'
    case 'ProductMarketFit':
      return 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-300'
    case 'Onboarding':
      return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300'
    case 'UserInterview':
      return 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300'
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300'
  }
}
